import { render, staticRenderFns } from "./LogisticsInformation.vue?vue&type=template&id=2e0cde92&scoped=true"
import script from "./LogisticsInformation.vue?vue&type=script&lang=js"
export * from "./LogisticsInformation.vue?vue&type=script&lang=js"
import style0 from "./LogisticsInformation.vue?vue&type=style&index=0&id=2e0cde92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0cde92",
  null
  
)

export default component.exports